import { render } from "./checkbox.html?vue&type=template&id=00478634&ts=true&external"
import script from "./checkbox.ts?vue&type=script&lang=ts&external"
export * from "./checkbox.ts?vue&type=script&lang=ts&external"

import "./checkbox.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__